import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var FaceVeryUnhappyOutlineSVG = function FaceVeryUnhappyOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16,2A14,14,0,1,1,2,16,14,14,0,0,1,16,2Zm0,2A12,12,0,1,0,28,16,12,12,0,0,0,16,4Zm0,14a8.48,8.48,0,0,1,5.71,2.29,1,1,0,0,1-1.42,1.42,6.24,6.24,0,0,0-8.58,0,1,1,0,0,1-1.42-1.42A8.48,8.48,0,0,1,16,18Zm-4-7a2,2,0,1,1-2,2A2,2,0,0,1,12,11Zm8,0a2,2,0,1,1-2,2A2,2,0,0,1,20,11Z"
  }));
};
FaceVeryUnhappyOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FaceVeryUnhappyOutlineSVG);